// extracted by mini-css-extract-plugin
export default {"ring_sm":"LoadingSpinner_ring_sm__UXUBC","ring":"LoadingSpinner_ring__jRj5q","ring_md":"LoadingSpinner_ring_md__pU1i4","ring_lg":"LoadingSpinner_ring_lg__vULmr"};